import Model, { attr } from '@ember-data/model';
import type { TeammateShapeKey } from 'uplisting-frontend/utils/teammate-shapes';

export type PermissionSettingDefaults = Partial<
  Record<TeammateShapeKey, boolean>
>;

export default class PermissionSettingModel extends Model {
  @attr('string') permission!: string;
  @attr('string') title!: string;
  @attr('string') category!: string;
  @attr('string-or-empty') subCategory!: string;
  @attr('array') availability!: TeammateShapeKey[];
  @attr('object') defaults!: PermissionSettingDefaults;
  @attr('boolean', { defaultValue: true }) applyToEveryone!: boolean;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'permission-setting': PermissionSettingModel;
  }
}
